var JourneyPlanner = (function() {
  'use strict';

  var opened = false;
  var expanded = false;
  var resultsShown = false;

  var ItinDepart = $("#ItinDepart");
  var ItinDepartHidden = $("#ItinDepartHidden");
  var ItinArrivee = $("#ItinArrivee");
  var ItinArriveeHidden = $("#ItinArriveeHidden");
  var jpForm = $("#jp-form");

  var markersVisible = [];
  var typeMarkersVisible = '';
  var geojson;

  var hover = false;

  var getFieldDepartWithKeyboard = true;
  var getFieldArriveeWithKeyboard = true;

  var typingTimer = 500;

  var mapGL = null;

  var ajaxForm = false;
  var requestP = null;

  var markerDeparture = null;
  var markerArrival = null;

  var typingTimer2;

  var currentSelectionDepart = -1;
  var currentSelectionArrivee = -1;

  var paddingOptions = {};

  var isOpen = function() {
    return opened;
  };

  var isExpanded = function() {
    return expanded;
  };

  var areResultsShown = function() {
    return resultsShown;
  };

  var hideMoreCriteriaBlock = function() {
    if (! $('#journey-planner-map-control #js-map-directions-extra-fields').hasClass('is-hidden')) {
      $('#journey-planner-map-control #js-map-directions-more').first().click();
    }
  };

  var setLoadingState = function(loading) {

    if (loading) {
      // Disable submit button
      $('#js-map-directions-form-submit').attr("disabled", "disabled");
      $('#js-map-directions-form-submit-loader').removeClass("is-hidden");

      // Disable departure/arrival reverse button
      $("#js-map-directions-reverse").attr("disabled", "disabled");

    } else {
      // Re-enable submit button
      $('#js-map-directions-form-submit').removeAttr("disabled");
      $('#js-map-directions-form-submit-loader').addClass("is-hidden");

      // Re-enable departure/arrival reverse button
      $("#js-map-directions-reverse").removeAttr("disabled");
    }
  };

  var removeMapLayers = function() {
    if (mapGL.getMapObject().getLayer('journey-planner-lines') !== undefined) {
      mapGL.getMapObject().removeLayer('journey-planner-lines');
      mapGL.getMapObject().removeLayer('journey-planner-markers');
    }
  };

  var removeMarkers = function() {
    if (markerDeparture != null) {
      markerDeparture.remove();
      markerDeparture = null;
    }
    if (markerArrival != null) {
      markerArrival.remove();
      markerArrival = null;
    }
  };

  var removeResults = function() {
    resultsShown = false;

    // Stop ajax calls
    ajaxForm = false;
    if (requestP) {
      requestP.abort();
    }

    // Revert form state
    setLoadingState(false);

    // Remove results
    $("#js-map-directions-results").addClass('is-hidden');
    $('#js-map-wrapper').removeClass('has-directions-panel-open--wide');
    $("#js-map-directions-results-content").empty();

    hideMoreCriteriaBlock();
    removeMapLayers();

    //clearAdditionalMarkers();
    CustomEvents.dispatchEvent('eventClosePopup');
  };

  var resetAddressFieldState = function(type) {

    if (type === 'departure') {
      ItinDepart.removeClass("has-error");
      ItinDepart.attr('placeholder', 'Rechercher une adresse...');
      ItinDepart.removeAttr('aria-invalid');
      ItinDepart.removeAttr('aria-errormessage');
    } else {
      ItinArrivee.removeClass("has-error");
      ItinArrivee.attr('placeholder', 'Rechercher une adresse...');
      ItinArrivee.removeAttr('aria-invalid');
      ItinArrivee.removeAttr('aria-errormessage');
    }
  };

  var resetForm = function() {
    jpForm.trigger('reset');
    resetAddressFieldState('departure');
    resetAddressFieldState('arrival');

    jpForm.find('.table-choice .table-cell').removeClass('is-active');
    jpForm.find('.table-choice .table-cell:first-child').addClass('is-active');

    JourneyPlannerDateTime.updateNow();
  };

  /**
   * zoom to fit drawn trip
   */
  var zoomTrip = function() {

    if (geojson && geojson.features[0]) {
      var bounds = new maplibregl.LngLatBounds();

      geojson.features.forEach(function (feature) {
        if (feature.geometry.type === 'LineString' || feature.geometry.type === 'MultiLineString') {
          bounds.extend(feature.properties.southWestPoint);
          bounds.extend(feature.properties.northEastPoint);
        }
      });

      mapGL.getMapObject().fitBounds(bounds, {padding: paddingOptions});
    }
  };

  var openShareModal = function(searchId) {

    var shareLink = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?searchId=' + searchId;
    var mapWrapper = $("#js-map-wrapper");
    if (mapWrapper.find('#js-map-share').length !== 0) {
      $('#js-map-share-input').val(shareLink);
      $('#js-map-share').addClass('is-open');
    } else {
      var html = '<div class="map-share" id="js-map-share">';
      html += '<div class="map-share__popup">';
      html += '<h3>Lien de partage</h3>';
      html += '<div class="map-share__body">';
      html += '<button type="button" id="js-map-share-close" class="delete is-large map-share__close" aria-label="Fermer la fênetre contextuelle"></button>';
      html += '<input value="' + shareLink + '" class="map-share__input" id="js-map-share-input" readonly>';
      html += '<button type="button" id="js-map-share-copy" class="button is-small map-share__copy mr-0">';
      html += '<span class="is-sr-only">Copier dans le presse papier</span>';
      html += '<span class="map-share__copy-tooltip is-invisible">Copié !</span>';
      html += '</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
      mapWrapper.append(html);
      $('#js-map-share').addClass('is-open');
    }

    $('#js-map-share-close').click(function () {
      $('#js-map-share').removeClass('is-open');
    });

    $('#js-map-share').click(function () {
      $('#js-map-share').removeClass('is-open');
    }).children().click(function () {
      return false;
    });

    $('#js-map-share-copy').click(function () {
      $('#js-map-share-input').select();
      document.execCommand("copy");
      $(this).children(".map-share__copy-tooltip").removeClass("is-invisible").delay(1000).queue(function( next ){
        $(this).addClass("is-invisible");
        $(this).dequeue();
      });
    });
  };

  var getTooltipContent = function(icon, content) {
    var ttContent = '<div class="tooltip-container">';

    if (icon !== '') {
      ttContent += '<div class="tooltip-icon">';
      ttContent += icon;
      ttContent += '</div>';
    }

    ttContent += '<div class="tooltip-content">';
    ttContent += content;
    ttContent += '</div>';
    ttContent += '</div>';

    return ttContent;
  };

  var getAddressTooltipContent = function(type, address) {
    var tooltipContent = '';

    if (type === 'departure') {
      var departureTime = '';
      if ($('#js-map-directions-results-content')) {
        if ($("#js-map-directions-results-content").html()) {
          departureTime = " à " + $(".js-map-trip-departure-time b").text();
        }
      }

      tooltipContent += '<p class="has-text-weight-bold">Départ' + departureTime + '</p>';
    }
    else {
      var arrivalTime = '';
      if ($('#js-map-directions-results-content')) {
        if ($("#js-map-directions-results-content").html()) {
          arrivalTime = " à " + $(".js-map-trip-arrival-time b").text();
        }
      }

      tooltipContent += '<p class="has-text-weight-bold">Arrivée' + arrivalTime + '</p>';
    }
    tooltipContent += '<p class="js-map-tooltip-address">' + address + '</p>';

    return tooltipContent;
  };

  var drawMarkers = function(idElement) {

    if ($(idElement).length === 0 || $(idElement).html() === "") {
      return false;
    }

    var jsonData = jQuery.parseJSON( $(idElement).html());
    markersVisible = [];

    $.each(jsonData, function(index, data) {
      if (data.type === "VELOV") {
        if (velovLayerObj != null) {
          markersVisible.push(data.id);
          typeMarkersVisible = data.type;
        }
      }
    });

    var objLayer = null;
    switch (typeMarkersVisible) {
      case 'VELOV': objLayer = velovLayerObj.velovLayerItinerary; break;
    }

    if (objLayer) {
      objLayer.showSpecificMarkers(markersVisible);
    }
  };

  /**
   * draw polyline trip and other minor elements on the map
   * @param {number} idElement
   * @param {string} tripId
   * @returns {boolean}
   */
  var drawPolyline = function(idElement, tripId) {

    if ($(idElement).html() === "") {
      return false;
    }
    var jsonData = jQuery.parseJSON($(idElement).html());

    geojson = {
      type: "FeatureCollection",
      features: []
    };

    var featureModel = {
      type: "Feature",
      properties: {
        type: '',
        color: '',
      },
      geometry: {
        type: "LineString",
        coordinates: []
      }
    };

    $.each(jsonData[tripId], function (index, section) {

      var feature = JSON.parse(JSON.stringify(featureModel));
      feature.properties.type = section.type;
      feature.properties.temps = section.duration;
      feature.properties.southWestPoint = section.southWestPoint;
      feature.properties.northEastPoint = section.northEastPoint;

      feature.geometry.type = section.geometry.type;
      feature.geometry.coordinates = section.geometry.coordinates;

      var featureIcon;
      var featureColor;

      switch (section.type) {
        case "WALK":
          featureColor = "#005bd9";
          featureIcon = 'walk.png';
          break;
        case "BICYCLE":
          featureColor = "#664D80";
          featureIcon = (section.isSharedBike) ? 'velov.png' : 'bike.png';
          break;
        case "UNKNOWN":
          featureColor = "#005bd9";
          featureIcon = 'walk.png';
      }

      feature.properties.color = featureColor;
      feature.properties.icon = IMG_PATH + '/Icons/journey-planner/' + featureIcon;
      geojson.features.push(feature);

      if (index > 0) {
        var featurePoint = JSON.parse(JSON.stringify(featureModel));
        featurePoint.properties.type = section.type;
        featurePoint.geometry.type = "Point";
        featurePoint.geometry.coordinates = [section.departurePoint[0], section.departurePoint[1]];

        var transportMode = section.type;
        if (transportMode === "UNKNOWN") {
          transportMode = "WALK";
        }
        transportMode = transportMode.toLowerCase();
        featurePoint.properties.icon = transportMode;

        if (!mapGL.getMapObject().hasImage(transportMode)) {
          mapGL.getMapObject().loadImage(IMG_PATH + '/Icons/journey-planner/interchange/' + transportMode + '.png',
            function (error, image) {
              if (error) {
                throw error;
              }

              mapGL.getMapObject().addImage(transportMode, image);
            }
          );
        }

        geojson.features.push(featurePoint);
      }
    });

    if (mapGL.getMapObject().getSource('journey-planner') !== undefined) {
      var source = mapGL.getMapObject().getSource('journey-planner');
      source.setData(geojson);
      if (mapGL.getMapObject().getLayer('journey-planner-lines')) {
        mapGL.getMapObject().removeLayer('journey-planner-lines');
        mapGL.getMapObject().removeLayer('journey-planner-markers');
      }
    }
    else {
      mapGL.getMapObject().addSource('journey-planner', {
        'type': 'geojson',
        'data': geojson
      });
    }

    mapGL.getMapObject().addLayer({
      'id': 'journey-planner-lines',
      'type': 'line',
      'source': 'journey-planner',
      'paint': {
        'line-width': 5,
        'line-color': ['get', 'color']
      },
      'layout': {
        "visibility": "visible",
        "line-cap": "round"
      },
      "filter": [
        "all",
        [
          "==",
          "$type",
          "LineString"
        ]
      ]
    });

    mapGL.getMapObject().on('mouseleave', 'journey-planner-lines', function(e){
      mapGL.getMapObject().getCanvas().style.cursor = '';
      hover = false;

      mapGL.tooltip.remove();
    });

    var coordinates;

    mapGL.getMapObject().on('mouseenter', 'journey-planner-lines', function(e) {
      mapGL.getMapObject().getCanvas().style.cursor = 'pointer';
      hover = true;
      var icon = '';

      if (!mapGL.tooltip.isOpen()) {

        icon = '<img src="' + e.features[0].properties.icon + '" alt="">';

        if (e.features[0].layer.type === "symbol") {
          coordinates = e.features[0].geometry.coordinates.slice();
        } else {
          coordinates = e.lngLat;
        }

        var time = parseInt(parseInt(e.features[0].properties.temps) / 60) + ' min';
        if (time === '0 min') {
          time = 'moins de 1 min';
        }

        var content = getTooltipContent(icon, time);

        if (content !== '') {
          mapGL.tooltip.setLngLat(coordinates).setHTML(content);
          mapGL.tooltip.addTo(mapGL.getMapObject());
        }
      }
    });

    mapGL.getMapObject().on('mousemove', 'journey-planner-lines', function(e) {
      if (hover) {
        var coordinates = e.lngLat;
        mapGL.tooltip.setLngLat(coordinates);
      }
    });

    mapGL.getMapObject().addLayer({
      'id': 'journey-planner-markers',
      'type': 'symbol',
      'source': 'journey-planner',
      'layout': {
        'icon-image': ['get', 'icon'],
        'icon-allow-overlap':true,
        'visibility': 'visible'
      },
      "filter": [
        "all",
        [
          "==",
          "$type",
          "Point"
        ]
      ],
      "minZoom": 10
    });

    // Zoom on the route
    zoomTrip();
  };

  var clearAdditionalMarkers = function () {

    if (markersVisible) {
      var objLayer = null;

      switch(typeMarkersVisible) {
        case 'VELOV' : objLayer = velovLayerObj.velovLayerItinerary; break;
      }

      if (objLayer) {
        objLayer.hideSpecificMarkers();
      }
    }
  };

  var addMarker = function(type, libelle, lat, lng) {
    var idFieldCoords = '';
    var idFieldAddress = '';
    var className = '';

    //ferme les popups et tooltip ouverts
    CustomEvents.dispatchEvent('eventClosePopup');

    //suppression de l'ancien itinéraire si existant
    if (areResultsShown()) {
      removeResults();
    }

    if (type === 'departure') {
      //suppression du précédent marker si il existe
      if (markerDeparture) {
        markerDeparture.remove();
      }
      className = "icon-map-departure";
      idFieldAddress = ("#ItinDepart");
      idFieldCoords = "#ItinDepartHidden";
    }
    else {
      //suppression du précédent marker si il existe
      if (markerArrival) {
        markerArrival.remove();
      }
      className = "icon-map-arrival";
      idFieldAddress = ("#ItinArrivee");
      idFieldCoords = "#ItinArriveeHidden";
    }

    $(idFieldAddress).val(libelle);
    $(idFieldCoords).val(lat + "," + lng);

    var el = document.createElement('div');
    el.className = className;
    el.setAttribute('data-type', type);
    el.setAttribute('data-lng', lng);
    el.setAttribute('data-lat', lat);
    el.setAttribute('data-address', libelle);

    el.addEventListener('mouseenter', function(e) {
      e.preventDefault();

      mapGL.tooltip.setHTML(getAddressTooltipContent($(this).data('type'), $(this).data('address')));
      mapGL.tooltip.setLngLat([$(this).data('lng'), $(this).data('lat')]).addTo(mapGL.getMapObject());
    });

    el.addEventListener('mouseleave', function(e) {
      mapGL.tooltip.remove();
    });

    // Ajout du marker
    var marker = new maplibregl.Marker({
      element: el,
      draggable: true,
      anchor: 'bottom'
    })
      .setLngLat([lng, lat])
      .addTo(mapGL.getMapObject());

    // AJOUT DES EVENEMENTS
    marker.on('dragend', function(e) {
      var markerElement = this.getElement();
      var type = $(markerElement).data('type');

      var lngLat = this._lngLat;
      $(markerElement).data('lng', lngLat.lng);
      $(markerElement).data('lat', lngLat.lat);

      //suppression de l'ancien itinéraire si existant et des anciens résultats
      removeResults();

      if (type === 'departure') {
        idFieldAddress = ("#ItinDepart");
        idFieldCoords = "#ItinDepartHidden";
      }
      else {
        idFieldAddress = ("#ItinArrivee");
        idFieldCoords = "#ItinArriveeHidden";
      }

      Geocoder.reverseGeocode([lngLat.lng, lngLat.lat], function(e) {
        $(markerElement).data('address', e.adresse);
        mapGL.tooltip.setHTML(getAddressTooltipContent(type, e.adresse));
        $(idFieldAddress).val(e.adresse);
        $(idFieldCoords).val(lngLat.lat + "," + lngLat.lng);
      });
    });

    if (type === 'departure') {
      markerDeparture = marker;
    }
    else {
      markerArrival = marker;
    }
  };

  var geocodeAddress = function(address, element) {
    Geocoder.geocode(address, function(results) {
      var foundAddressInBounds = false;
      var i = 0;

      while (!foundAddressInBounds && i < results.data.features.length) {
        var lng = results.data.features[i].geometry.coordinates[0];
        var lat = results.data.features[i].geometry.coordinates[1];

        if (Utils.inBounds({'lng': lng, 'lat': lat}, mapGL.getMapObject().getMaxBounds())) {
          foundAddressInBounds = true;
          let formattedAddress = Geocoder.formatAddress(results.data.features[i].properties);

          $("#" + element + "Hidden").val(lat + "," + lng);
          if (element === "ItinDepart") {
            addMarker("departure", formattedAddress, lat, lng);
          }
          if (element === "ItinArrivee") {
            addMarker("arrival", formattedAddress, lat, lng);
          }

          mapGL.getMapObject().flyTo({center: [lng, lat]});
        }

        i++;
      }
    });
  };

  var open = function() {
    opened = true;
    $('#journey-planner-map-control').removeClass('is-hidden');
    $('#js-map-wrapper').addClass('has-directions-panel-open');
    SearchAddressControl.close();
    ItinDepart.val($('#js-map-address').val());
    ItinDepartHidden.val($('#js-map-address-hidden').val());
    if (ItinDepart.val() !== '') {
      geocodeAddress(ItinDepart.val(), "ItinDepart");
    }
  };

  var close = function() {
    opened = false;
    $('#journey-planner-map-control').addClass('is-hidden');
    $('#js-map-wrapper').removeClass('has-directions-panel-open');

    $('#js-map-address').val(ItinDepart.val());
    $('#js-map-address-hidden').val(ItinDepartHidden.val());
    SearchAddressControl.open();

    removeResults();
    removeMarkers();
    resetForm();
  };

  var expand = function() {
    expanded = true;
    $('#journey-planner-map-control').removeClass('is-reduced');
    $('#js-map-directions-expand').removeClass('is-reduced');
    $('#js-map-directions-expand').attr("title", "Réduire le panel du calculateur d'itinéraire");
  };

  var reduce = function() {
    expanded = false;
    $('#journey-planner-map-control').addClass('is-reduced');
    $('#js-map-directions-expand').addClass('is-reduced');
    $('#js-map-directions-expand').attr("title", "Agrandir le panel du calculateur d'itinéraire");

  };

  /**
   * make a map zoom on coords got from element
   * @param {object} element
   */
  var zoomPathLink = function(element) {

    if (element.attr('data-pathlink-zoom-coords')) {
      var coordinates = element.attr('data-pathlink-zoom-coords').split(",");
      var bounds;

      coordinates.forEach(function (coordinate, index) {

        if (coordinate !== '') {
          var lonLat = coordinate.split(' ');

          if (index === 0) {
            bounds = new maplibregl.LngLatBounds([lonLat[0],lonLat[1]],[lonLat[0],lonLat[1]]);
          }
          else {
            bounds.extend([lonLat[0], lonLat[1]]);
          }
        }
      });

      mapGL.getMapObject().fitBounds(bounds, {padding: paddingOptions});
    }
  };

  /**
   * verify if fields are correctly filled
   * @returns {boolean}
   */
  var validateForm = function() {

    var isInvalid = false;
    resetAddressFieldState('departure');
    resetAddressFieldState('arrival');

    // Check departure address field
    if (!ItinDepart.val()) {
      isInvalid = true;
      ItinDepart.addClass("has-error");
      ItinDepart.attr('placeholder', 'Merci de remplir ce champ');
      ItinDepart.attr("aria-invalid", "true");
      ItinDepart.attr("aria-errormessage", "Merci de remplir ce champ");
    }

    // Check arrival address field
    if (!ItinArrivee.val()) {
      isInvalid = true;
      ItinArrivee.addClass("has-error");
      ItinArrivee.attr('placeholder', 'Merci de remplir ce champ');
      ItinArrivee.attr("aria-invalid", "true");
      ItinArrivee.attr("aria-errormessage", "Merci de remplir ce champ");
    }

    if (isInvalid) {
      return false;
    }

    // Check departure coordinates
    if (ItinDepartHidden.val() === "" && ItinDepart.val() !== "") {
      isInvalid = true;
      ItinDepart.val("");
      ItinDepart.addClass("has-error");
      ItinDepart.attr('placeholder', 'Adresse non reconnue');
      ItinDepart.attr("aria-invalid", "true");
      ItinDepart.attr("aria-errormessage", "Adresse non reconnue");
    }

    // Check arrival coordinates
    if (ItinArriveeHidden.val() === "" && ItinArrivee.val() !== "") {
      isInvalid = true;
      ItinArrivee.val("");
      ItinArrivee.addClass("has-error");
      ItinArrivee.attr('placeholder', 'Adresse non reconnue');
      ItinArrivee.attr("aria-invalid", "true");
      ItinArrivee.attr("aria-errormessage", "Adresse non reconnue");
    }

    if (isInvalid) {
      return false;
    }

    //si plus tard et que la date est vide
    if ($("input[name=quand]:checked").val() === "après") {
      if ($("#jp-date").val() === "") {
        $("#jp-date").css({"border":"red 1px solid"});
        return false;
      }
      else {
        $("#jp-date").css({"border":"1px solid #9c9d9f"});
      }
    }

    return true;
  };

  var initEvents = function() {

    mapGL.getMapObject().on('contextmenu', function (e) {

      // Right click
      if (e.originalEvent.button === 2) {
        CustomEvents.dispatchEvent('eventClosePopup');
        var coords = e.lngLat;
        var bounds = mapGL.getMapObject().getBounds();

        if (Utils.inBounds(coords, bounds)) {

          Geocoder.reverseGeocode([coords.lng, coords.lat], function(e) {
            var address = e.adresse;

            var popupContent = '<div class="map-popup pl-0">';
            popupContent += '<span class="map-popup__title">Adresse</span>';
            popupContent += '<hr>';
            popupContent += '<span class="map-popup__city">' + address + '</span>';
            popupContent += JourneyPlanner.getPopupContentActions([coords.lng, coords.lat], address);
            popupContent += '</div>';

            if (mapGL.popup.isOpen()) {
              mapGL.popup.remove();
            }

            mapGL.popup = new maplibregl.Popup({
              className: 'popup-contextmenu',
              focusAfterOpen: false
            })
              .setLngLat(coords)
              .setHTML(popupContent)
              .addTo(mapGL.getMapObject());
          });
        }
      }
    });
  };

  var setSelectedDepart = function(menuitem) {
    $('#autoDepartSelect').find('.selectable').removeClass("hovered");
    $('#autoDepartSelect').find('.selectable').eq(menuitem).addClass("hovered").click();

    $('#ItinDepart').val($('#autoDepartSelect').find('.selectable').eq(menuitem).find("span").text());
  };

  var navigateDepart = function(direction) {
    if (direction === 'up') {
      if (currentSelectionDepart > 0) {
        currentSelectionDepart -= 1;
      }
      else {
        currentSelectionDepart = $('#autoDepartSelect').find('.selectable').length-1;
      }
    }

    if (direction === 'down') {
      if (currentSelectionDepart < $('#autoDepartSelect').find('.selectable').length-1) {
        currentSelectionDepart += 1;
      }
      else {
        currentSelectionDepart = 0;
      }
    }
    setSelectedDepart(currentSelectionDepart);
  };

  var setSelectedArrivee = function(menuitem) {
    $('#autoArriveeSelect').find('.selectable').removeClass("hovered");
    $('#autoArriveeSelect').find('.selectable').eq(menuitem).addClass("hovered").click();

    $('#ItinArrivee').val($('#autoArriveeSelect').find('.selectable').eq(menuitem).find("span").text());
  };

  var navigateArrivee = function(direction) {
    if (direction === 'up') {
      if (currentSelectionArrivee > 0) {
        currentSelectionArrivee -= 1;
      }
      else {
        currentSelectionArrivee = $('#autoArriveeSelect').find('.selectable').length-1;
      }
    }
    if (direction === 'down') {
      if (currentSelectionArrivee < $('#autoArriveeSelect').find('.selectable').length-1) {
        currentSelectionArrivee += 1;
      }
      else {
        currentSelectionArrivee = 0;
      }
    }
    setSelectedArrivee(currentSelectionArrivee);
  };

  var reverseMarkers = function() {
    let departureAddress = $('#ItinArrivee').val();
    let arrivalAddress = $('#ItinDepart').val();

    if (markerDeparture !== null && markerArrival === null) {
      let departureLngLat = markerDeparture.getLngLat();
      addMarker("arrival", departureAddress, departureLngLat.lat , departureLngLat.lng);
      markerDeparture.remove();
      markerDeparture = null;
    } else if (markerDeparture === null && markerArrival !== null) {
      let arrivalLngLat = markerArrival.getLngLat();
      addMarker("departure", arrivalAddress, arrivalLngLat.lat , arrivalLngLat.lng);
      markerArrival.remove();
      markerArrival = null;
    } else if (markerDeparture !== null && markerArrival !== null) {
      let departureLngLat = markerDeparture.getLngLat();
      let arrivalLngLat = markerArrival.getLngLat();
      addMarker("arrival", departureAddress, departureLngLat.lat , departureLngLat.lng);
      addMarker("departure", arrivalAddress, arrivalLngLat.lat , arrivalLngLat.lng);
    }
  };

  var getPopupContentActions = function(coords, label) {
    var popupContent = '<div class="map-popup__actions">';

    popupContent += '<a href="javascript:;" title="Choisir comme point de départ" class="map-popup__to-start js-map-popup-to-start" ';
    popupContent += 'data-latitude="' + coords[1] + '" data-longitude="' + coords[0] + '" data-label="' + label + '">';
    popupContent += '<img src="' + IMG_PATH + '/Unsprited/mapicons/departure.svg" alt="">';
    popupContent += '</a>';

    popupContent += '<a href="javascript:;" title="Choisir comme point d\'arrivée" class="map-popup__to-arrival js-map-popup-to-arrival" ';
    popupContent += 'data-latitude="' + coords[1] + '" data-longitude="' + coords[0] + '" data-label="' + label + '">';
    popupContent += '<img src="' + IMG_PATH + '/Unsprited/mapicons/arrival.svg" alt="">';
    popupContent += '</a>';

    popupContent += '</div>';

    return popupContent;
  };

  return {
    removeResults: removeResults,
    areResultsShown: areResultsShown,
    isOpen: isOpen,
    open: open,
    close: close,
    isExpanded: isExpanded,
    expand: expand,
    clearAdditionalMarkers: clearAdditionalMarkers,
    removeMapLayers: removeMapLayers,
    getPopupContentActions: getPopupContentActions,

    init: function(map) {
      mapGL = map;

      if (window.matchMedia("(max-width: 1024px)").matches) {
        paddingOptions = {top: 150, right: 75, bottom: 25, left: 25};
      } else {
        paddingOptions = {top: 150, right: 75, bottom: 25, left: 550};
      }

      $('#journey-planner-map-control #js-map-directions-close').click(function () {
        close();
      });

      $('#journey-planner-map-control #js-map-directions-more').click(function () {
        var label = $(this).text();
        var altLabel = $(this).data('altlabel');
        $(this).text(altLabel);
        $(this).data('altlabel', label);
        $(this).toggleClass('is-open');
        $('#journey-planner-map-control #js-map-directions-extra-fields').toggleClass('is-hidden');
        $('#journey-planner-map-control #js-map-directions-results').toggleClass('is-reduced');
      });

      // Geolocation
      $("#journey-planner-map-control .js-map-btn-geolocate").click(function() {
        var element = $(this).data('element');
        GeolocationControl.removeMarker();

        if (navigator.geolocation) {
          var options = {
            enableHighAccuracy: true,
            timeout: 6000,
            maximumAge: 0
          };

          navigator.geolocation.getCurrentPosition(function(position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            var bounds = mapGL.getMapObject().getMaxBounds();

            if (Utils.inBounds(new maplibregl.LngLat(lng, lat), bounds)) {
              Geocoder.reverseGeocode([lng,lat], function(e) {
                var address = e.adresse;

                if (element === "ItinDepart") {
                  addMarker("departure", address, lat, lng);
                }
                else {
                  addMarker("arrival", address, lat, lng);
                }
              });
            }
            else {
              GeolocationControl.handleNoGeolocation("Votre position est située en dehors de la zone de couverture de la carte.");
            }
          }, function() {
            GeolocationControl.handleNoGeolocation("Votre position ne peut pas être déterminée.");
          }, options);

        } else {
          GeolocationControl.handleNoGeolocation("Votre position ne peut pas être déterminée.");
        }
      });

      // Reverse departure/arrival
      $("#journey-planner-map-control #js-map-directions-reverse").click(function () {
        resetAddressFieldState('departure');
        resetAddressFieldState('arrival');

        // Reverse input fields
        var tempDepart = $('#ItinDepart').val();
        var tempDepartHidden = $('#ItinDepartHidden').val();
        var tempDepartType = $('#ItinDepart').data('type');

        $('#ItinDepart').val($('#ItinArrivee').val()).data('type', $('#ItinArrivee').data('type'));
        $('#ItinDepartHidden').val($('#ItinArriveeHidden').val());
        $('#ItinArrivee').val(tempDepart).data('type', tempDepartType);
        $('#ItinArriveeHidden').val(tempDepartHidden);

        reverseMarkers();
        removeResults();
      });

      $("#js-map-directions-field-from .js-map-directions-form-clear").click(function () {
        $("#ItinDepart, #ItinDepartHidden").val("");
        resetAddressFieldState('departure');

        if (areResultsShown()) {
          removeResults();
        }

        // Remove marker
        if (markerDeparture != null) {
          markerDeparture.remove();
          markerDeparture = null;
        }
      });

      $("#js-map-directions-field-to .js-map-directions-form-clear").click(function () {
        $("#ItinArrivee, #ItinArriveeHidden").val("");
        resetAddressFieldState('arrival');

        if (areResultsShown()) {
          removeResults();
        }

        // Remove marker
        if (markerArrival != null) {
          markerArrival.remove();
          markerArrival = null;
        }
      });

      $('#journey-planner-map-control #js-map-directions-expand').click(function () {
        if ($(this).hasClass('is-reduced')) {
          expand();
        } else {
          reduce();
        }
      });

      $("#jp-form").submit(function (event) {
        event.preventDefault();

        CustomEvents.dispatchEvent('eventClosePopup');
        ajaxForm = true;

        if (validateForm()) {

          var tripmode = $("#tripmode");

          var latD = ItinDepartHidden.val().split(",")[0];
          var lngD = ItinDepartHidden.val().split(",")[1];
          var latA = ItinArriveeHidden.val().split(",")[0];
          var lngA = ItinArriveeHidden.val().split(",")[1];

          if (markerDeparture === null) {
            addMarker("departure", $('#ItinDepart').val(), latD , lngD);
          }

          if (markerArrival === null) {
            addMarker("arrival", $('#ItinArrivee').val(), latA, lngA);
          }

          JourneyPlannerDateTime.updateNow();

          var timeSelected = JourneyPlannerDateTime.getSelectedTime();
          var dateSelected = JourneyPlannerDateTime.getSelectedDate();

          var now = JourneyPlannerDateTime.getNow();
          var when = (moment(now).isSame(dateSelected, 'day') && moment(now).isSame(timeSelected))? 'maintenant' : 'après';
          var plusTardDate = moment(dateSelected).format('YYYY-MM-DD');
          var plusTardHeures = moment(timeSelected).format('HH');
          var plusTardMinutes = moment(timeSelected).format('mm');
          var plusTardQuand = $("input[name=plustardquand]:checked", "#jp-form");
          var bikeSpeedChecked = $("input[name=bikeSpeed]:checked", "#jp-form");
          var typeVeloLimiter = $("input[name=typeVeloLimiter]", "#jp-form");
          var bikeType = $("input[name=bikeType]:checked", "#jp-form");

          requestP = $.ajax({
            type: "GET",
            url: "/journey_planner_search",
            data:
              'tripmode=' + tripmode.val() +
              '&bikeType=' + bikeType.val() +
              '&ItinDepart=' + ItinDepart.val() +
              '&ItinDepartHidden=' + ItinDepartHidden.val() +
              '&ItinArrivee=' + ItinArrivee.val() +
              '&ItinArriveeHidden=' + ItinArriveeHidden.val() +
              '&quand=' + when +
              '&plustarddate=' + plusTardDate +
              '&plustardquand=' + plusTardQuand.val() +
              '&plustardheures=' + plusTardHeures +
              '&plustardminutes=' + plusTardMinutes +
              '&bikeSpeed=' + bikeSpeedChecked.val() +
              '&typeVeloLimiter=' + (typeVeloLimiter.is(":checked") ? "true" : "false"),
            success: function(data) {

              if (ajaxForm) {
                resultsShown = true;

                // Clear previous results
                if ($("#js-map-directions-results-content").html()) {
                  $("#js-map-directions-results-content").empty();
                  removeMapLayers();
                }

                // Show result
                $("#js-map-directions-results-content").html(data);
                $("#js-map-directions-results").removeClass('is-hidden');
                $('#js-map-wrapper').addClass('has-directions-panel-open--wide');

                hideMoreCriteriaBlock();

                var tripElement = $("#js-map-directions-results .js-map-trip-item").first();
                if (tripElement !== undefined) {
                  var tripId = tripElement.attr('data-tripid');
                  var tripJson = tripElement.find('.js-trip-map-json');

                  if (tripId !== "") {

                    drawPolyline(tripJson, tripId);
                    // Draw route
                    // drawMarkers('#jsonAdditionalMarkers-'+ tripId);
                    zoomTrip();

                    // zoom sur l'ensemble de l'itinéraire
                    $('#js-map-directions-results #js-map-trip-actions-zoom').click(function() {
                      if (window.matchMedia("(max-width: 1024px)").matches) {
                        reduce();
                      }
                      zoomTrip();
                    });

                    $('#js-map-directions-results #js-map-trip-actions-share').click(function() {
                      openShareModal($(this).data('searchid'));
                    });

                    $('#js-map-directions-results .js-pathlink-item').click(function() {
                      if (window.matchMedia("(max-width: 1024px)").matches) {
                        reduce();
                      }
                      zoomPathLink($(this));
                    });
                  }
                }

                $('#js-map-directions-results #js-map-trip-debug-link').click(function(e) {
                  e.preventDefault();

                  if ($("#js-map-trip-debug").hasClass('is-hidden')) {
                    $(this).html('Masquer les informations techniques');
                  } else {
                    $(this).html('Afficher les informations techniques');
                  }

                  $("#js-map-trip-debug").toggleClass('is-hidden');
                });

              }
              else {
                this.abort();
              }
            },
            error: function(xhr, desc, err) {
              setLoadingState(false);
            },
            beforeSend: function(xhr, opts) {
              setLoadingState(true);
            },
            complete: function() {
              setLoadingState(false);

              //vider les champs d'autocomplétion
              $("li[data-type=autocomplete]").each(function() {
                $(this).remove();
              });
            }
          });
        }
      });

      $(document).on("click touchstart", ".js-map-popup-to-start", function(e) {
        e.stopPropagation();

        if (!JourneyPlanner.isOpen()) {
          JourneyPlanner.open();
        } else if (!JourneyPlanner.isExpanded()) {
          JourneyPlanner.expand();
        }

        mapGL.popup.remove();
        addMarker("departure", $(this).data('label'), $(this).data('latitude'), $(this).data('longitude'));
      });

      $(document).on("click touchstart", ".js-map-popup-to-arrival", function(e) {
        e.stopPropagation();

        if (!JourneyPlanner.isOpen()) {
          JourneyPlanner.open();
        } else if (!JourneyPlanner.isExpanded()) {
          JourneyPlanner.expand();
        }

        mapGL.popup.remove();
        addMarker("arrival", $(this).data('label'), $(this).data('latitude'), $(this).data('longitude'));
      });

      let params = (new URL(document.location)).searchParams;
      if (params.get("searchId") !== null) {
        $.ajax({
          type: "GET",
          url: "/journey_planner_share",
          data: '&searchId=' + params.get("searchId"),
          success: function(data) {
            $('html, body').animate({scrollTop: $('a[name="map-anchor"]').offset().top}, 'slow');
            JourneyPlanner.open();

            $('#ItinDepart').val(data.ItinDepart);
            $('#ItinDepartHidden').val(data.ItinDepartHidden);
            $('#ItinArrivee').val(data.ItinArrivee);
            $('#ItinArriveeHidden').val(data.ItinArriveeHidden);

            if (data.plustardquand === "maintenant") {
              $('#jp-where-departure').prop("checked", true);
            } else {
              $('#jp-where-arrival').prop("checked", true);
              let selectedDate = new Date(data.plustarddate);
              let selectedTime = new Date(data.plustarddate);
              selectedTime.setHours(parseInt(data.plustardheures, 10));
              selectedTime.setMinutes(parseInt(data.plustardminutes, 10));
              JourneyPlannerDateTime.setSelectedDate(selectedDate);
              JourneyPlannerDateTime.setSelectedTime(selectedTime);
            }

            if (data.bikeType === "velo") {
              $('#jp-biketype-mine').prop("checked", true);
            } else {
              $('#jp-biketype-velov').prop("checked", true);
            }

            if (data.bikeSpeed === "classic") {
              $('#jp-bikespeed-classic').prop("checked", true);
            } else {
              $('#jp-bikespeed-electric').prop("checked", true);
            }

            if (data.typeVeloLimiter === "true") {
              $('#typeVeloLimiter').prop("checked", true);
            } else {
              $('#typeVeloLimiter').prop("checked", false);
            }

            $('#jp-form').submit();
          }
        });
      }

      initEvents();
    },

    initAfterLoad: function() {

      //gestion du clic sur le favori d'adresse
      $(document).on("click", "#autoDepartSelect .selectable", function() {
        //renseigner le data-type si histo

        // if (typeof $(this).data('type') == "undefined") {
        //   //quel type d'historique ?
        //   var typeDepart = JSON.parse(localStorage.getItem("HistoriqueTypes"));
        //   var content = typeDepart.content.split("|");
        $(this).data('type', 'autocomplete-address');
        // }

        //renseigner le type sélectionné
        var address = $(this).text();
        $("#ItinDepart").data('type', $(this).data('type')).val(address);

        //type address
        if ($(this).data('type') === "autocomplete-address") {
          if (!$(this).attr('data-latitude') || $(this).attr('data-latitude') === 0 ||
             !$(this).attr('data-longitude') || $(this).attr('data-longitude') === 0) {

            Geocoder.geocode( address, function(results) {
              var lat = results.data.features[0].geometry.coordinates[1];
              var lon = results.data.features[0].geometry.coordinates[0];

              $("#ItinDepartHidden").val(lat + "," + lon);
              addMarker("departure", address, lat, lon);
            });
          }
          else {
            addMarker("departure", address,  $(this).data('latitude'), $(this).data('longitude'));
          }
        }
      }).mouseup(function() {
        $("#autoDepart").hide();
      }).on("click", "#autoArriveeSelect .selectable", function() {
        //renseigner le data-type si histo
        //if (typeof $(this).data('type') == "undefined") {

        //quel type d'historique ?
        // var typeArrivee = JSON.parse(localStorage.getItem("HistoriqueTypes"));
        // var content = typeArrivee.content.split("|");
        // $(this).data('type', content[$(this).index()]);

        // if ($(this).data('type') == "undefined") {
        $(this).data('type', 'autocomplete-address');
        // }
        //}

        //renseigner le type sélectionné
        var address = $(this).text();
        $("#ItinArrivee").data('type', $(this).data('type')).val(address);

        //type address
        if ($(this).data('type') === "autocomplete-address") {
          if (!$(this).attr('data-latitude') || $(this).attr('data-latitude') === 0 || !$(this).attr('data-longitude') || $(this).attr('data-longitude') === 0) {

            Geocoder.geocode(address, function(results) {
              var lat = results.data.features[0].geometry.coordinates[1];
              var lon = results.data.features[0].geometry.coordinates[0];
              $("#ItinArriveeHidden").val(lat + "," + lon);
              addMarker("arrival", address, lat, lon);
            });

          }
          else {
            addMarker("arrival", address, $(this).data('latitude'), $(this).data('longitude'));
          }
        }

      }).mouseup(function() {
        $("#autoArrivee").hide();
      });

      //récupérer les coordonnées de l'adresse saisie
      $('#ItinDepart').focusout(function () {
        //saisie sans choix
        setTimeout(function () {
          if ($("#ItinDepartHidden").val() === "" && $("#ItinDepart").val() !== "") {
            geocodeAddress($("#ItinDepart").val(), "ItinDepart");
          }
        }, 500);

      }).focus(function () {
        $("#autoDepart").show();
      }).keyup(function () {
        $("#ItinDepartHidden").val("");

        if (!getFieldDepartWithKeyboard) {
          $("#autoDepart").show();
          $("#autoDepart").html("<ul id='autoDepartSelect'></ul>");

          if ($("#ItinDepart").val().length >= 3) {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(AutocompleteService.send_autocompletion_depart_GMapJS, 200);
          }
        }
      }).keydown(function(){
        clearTimeout(typingTimer);
      }).click(function (e) {
        e.stopPropagation();
        resetAddressFieldState('departure');
        $("#autoDepart").show();
        $("#autoDepart").html("<ul id='autoDepartSelect'></ul>");
      }).bind('keydown', function(e) {
        $("#autoDepartSelect div .selectable").removeClass("hovered");

        switch(e.keyCode) {
          case 9:
            //tab = true;
            $("#autoDepart").hide();
            $("#autoArrivee").show();
            break;
          case 38:
            getFieldDepartWithKeyboard = true;
            navigateDepart('up');
            $("#ItinDepart").val($("#autoDepartSelect").find("div .selectable.hovered").text());
            break;
          case 40:
            getFieldDepartWithKeyboard = true;
            navigateDepart('down');
            $("#ItinDepart").val($("#autoDepartSelect").find("div .selectable.hovered").text());
            break;
          case 13:
            e.preventDefault();
            $("#autoDepart").hide();
            break;
          default :
            getFieldDepartWithKeyboard = false;
            $("#autoDepartSelect").find("div .selectable").removeClass("hovered");
            break;
        }
      });

      //récupérer les coordonnées de l'adresse saisie
      $('#ItinArrivee').focusout(function () {
        //saisie sans choix
        setTimeout(function () {
          if ($("input[name=ItinArriveeHidden]").val() === "" && ($("#ItinArrivee").val() !== "" || $("#ItinArrivee").val() !== "#")) {
            geocodeAddress($("#ItinArrivee").val(), "ItinArrivee");
          }
        }, 500);

      }).focus(function () {
        $("#autoArrivee").show();
      }).keyup(function () {
        $("#ItinArriveeHidden").val("");

        if (!getFieldArriveeWithKeyboard) {
          $("#autoArrivee").show();
          $("#autoArrivee").html("<ul id='autoArriveeSelect'></ul>");

          if ($("#ItinArrivee").val().length >= 3) {
            clearTimeout(typingTimer);
            typingTimer2 = setTimeout(AutocompleteService.send_autocompletion_arrivee_GMapJS, 200);
          }
        }
      }).keydown(function(){
        clearTimeout(typingTimer2);
      }).click(function (e) {
        e.stopPropagation();
        resetAddressFieldState('arrival');
        $("#autoArrivee").show();
        $("#autoArrivee").html("<ul id='autoArriveeSelect'></ul>");
      }).bind('keydown', function(e) {

        $("#autoArriveeSelect div .selectable").removeClass("hovered");

        if (e.shiftKey && e.keyCode === 9) { //Alt + Tab key
          //tab = true;
          $("#autoArrivee").hide();
          $("#autoDepart").show();
        }

        switch(e.keyCode) {
          case 9:
            //tab = true;
            $("#autoArrivee").hide();
            $("#autoDepart").show();
            break;
          case 38:
            getFieldArriveeWithKeyboard = true;
            navigateArrivee('up');
            $("#ItinArrivee").val($("#autoArriveeSelect div .selectable.hovered").text());
            break;
          case 40:
            getFieldArriveeWithKeyboard = true;
            navigateArrivee('down');
            $("#ItinArrivee").val($("#autoArriveeSelect div .selectable.hovered").text());
            break;
          case 13:
            e.preventDefault();
            $("#autoArrivee").hide();
            break;
          default :
            getFieldArriveeWithKeyboard = false;
            $("#autoArriveeSelect div .selectable").removeClass("hovered");
            break;
        }
      });
    }
  };

}());
